;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { MultilinkStoryblok } from '@qogita/cms'
import { useAuthentication } from 'src/core/authentication/provider'

type MultilinkField = Exclude<
  MultilinkStoryblok,
  { linktype?: 'email' } | { linktype?: 'asset' }
>

export type CtaBlok = {
  anonymousCtaLabel: string
  anonymousCtaLink: MultilinkField
  authenticatedCtaLabel?: string
  authenticatedCtaLink?: MultilinkField
}

export function useGetCta(blok: CtaBlok) {
  const { isAuthenticated } = useAuthentication()

  const { label, link } =
    isAuthenticated && blok.authenticatedCtaLabel && blok.authenticatedCtaLink
      ? {
          label: blok.authenticatedCtaLabel,
          link: blok.authenticatedCtaLink,
        }
      : {
          label: blok.anonymousCtaLabel,
          link: blok.anonymousCtaLink,
        }

  const href = link.story?.url ?? link.url
  const openNewTab = link.target === '_blank'

  return { label, href, openNewTab }
}
